import { Link } from 'react-router-dom'
import { ChatLinkIcon } from './ChatLinkIcon'
import ChatExpandTooltip from './ChatExpandTooltip'
import { useChatAccountNames } from './chatAccountNames'

type AccountNumberLinkProps = {
  accountNumber: string
  to: string
  className?: string
}

/** Renders a king account deep link; account name expands in a tooltip when available. */
const AccountNumberLink: React.FC<AccountNumberLinkProps> = ({ accountNumber, to, className }) => {
  const namesByNumber = useChatAccountNames()
  const name = namesByNumber[accountNumber]?.trim() || null

  return (
    <ChatExpandTooltip content={name}>
      <Link to={to} className={className} aria-label={accountNumber}>
        <ChatLinkIcon kind="internal" href={to} />
      <span className="min-w-0 underline underline-offset-2">
          <span className="font-mono text-[12px]">{accountNumber}</span>
        </span>
      </Link>
    </ChatExpandTooltip>
  )
}

export default AccountNumberLink
